/**
 * Created by andrey on 20.02.2021.
 */

const FogBlockedGround = function (fogs, slot) {
    FogBlock.call(this, FogBlockedGround.ID, fogs);

    this.state = FogBlock.CANTOPEN;
    this.showUpActions = [];

    this.opened = new OpenedGrounds(slot);
};

FogBlockedGround.prototype = Object.create(FogBlock.prototype);
FogBlockedGround.prototype.constructor = FogBlockedGround;

FogBlockedGround.prototype.load = function () {
    const map = this.fogs.map2d;

    this.opened.load();

    if (this.opened.isEmpty()) {
        return;
    }

    for (let y = 0; y < map.getHeight(); y++) {
        for (let x = 0; x < map.getWidth(); x++) {
            if (!this.opened.has(x, y) && map.isGround(x, y) && !map.getFog(x, y)) {
                this.add(x, y);
            }
        }
    }
};

FogBlockedGround.prototype.updateOpenedGrounds = function () {
    this.opened.update();
};

FogBlockedGround.prototype.click = function () {
    cleverapps.centerHint.createTextHint(Messages.get("FogBlockedGround.clickMessage"));
};

FogBlockedGround.prototype.updateBlockedGrounds = function (callback, silent) {
    callback = callback || function () {};
    const BLOCKED = 1;
    const AVAILABLE = 2;

    const used = {};
    const dirs = ISO_NEIGHBORS;

    const queue = [];
    let index = 0;

    const map = this.fogs.map2d;

    const processCell = function (index) {
        const current = queue[index].cell;
        let status = queue[index].status;

        const usedStatus = used[current.x + current.y * map.getWidth()] || 0;

        if (status <= usedStatus || !map.isGround(current.x, current.y) && !map.isWaterUnit(current.x, current.y)) {
            return;
        }

        const fogTile = map.getFog(current.x, current.y);
        if (fogTile && fogTile.fogBlock !== this) {
            return;
        }

        let data;
        let unit = map.getUnit(current.x, current.y);
        if (unit) {
            unit = unit.head || unit;
        }

        let fakeUnit = fogTile && fogTile.getFakeUnit();
        if (fakeUnit) {
            fakeUnit = fakeUnit.head || fakeUnit;
            if (map.getFog(fakeUnit.x, fakeUnit.y)) {
                unit = fakeUnit;
            }
        }

        if (unit) {
            data = Families[unit.code].units[unit.stage];
            const shape = Unit.GetShape(unit);
            if (shape.length > 1) {
                shape.forEach((part) => {
                    queue.push({
                        cell: cc.p(unit.x + part.x, unit.y + part.y),
                        status
                    });
                });
            }
        }

        used[current.x + current.y * map.getWidth()] = status;

        if (unit) {
            if (unit instanceof Unit && unit.isGrounded() || unit.grounded || data.stopsfog && unit.stopsfog !== false) {
                status = BLOCKED;
            }
        }

        for (let i = 0; i < dirs.length; i++) {
            queue.push({
                cell: cc.p(current.x + dirs[i].x, current.y + dirs[i].y),
                status
            });
        }
    }.bind(this);

    Object.keys(this.fogs.config).forEach((code) => {
        const head = map.regions[code] && map.regions[code].head;
        const config = this.fogs.config[code];
        if (!head || used[head.x + head.y * map.getWidth()] && !config.money) {
            return;
        }

        queue.push({
            cell: head,
            status: AVAILABLE
        });

        while (index < queue.length) {
            processCell(index++);
        }
    });

    const cells = (this.opened.isEmpty() ? map.listAvailableUnits() : this.opened.listCells()).filter((cell) => {
        if (cell.head) {
            cell = cell.head;
        }

        return map.isGround(cell.x, cell.y) && !map.getFog(cell.x, cell.y);
    });

    cells.forEach((cell) => {
        queue.push({ cell, status: AVAILABLE });

        while (index < queue.length) {
            processCell(index++);
        }
    });

    for (let y = 0; y < map.getHeight(); y++) {
        for (let x = 0; x < map.getWidth(); x++) {
            if (used[x + y * map.getWidth()] === BLOCKED && !map.getFog(x, y)) {
                this.add(x, y);
            }
        }
    }

    const openTiles = this.tiles.filter((tile) => used[tile.x + tile.y * map.getWidth()] !== BLOCKED);

    openTiles.forEach((tile) => {
        tile.open();
        this.opened.add(tile.x, tile.y);
    });

    callback = cleverapps.wait(openTiles.length, callback);

    const showUpActions = [];

    openTiles.forEach((tile) => {
        if (silent) {
            tile.animateOpen(true, callback);
            return;
        }

        const unit = Map2d.currentMap.getUnit(tile.x, tile.y);
        const unitBundle = unit && unit.getData().hasShowUp && UnitView.GetUnitBundle(unit);
        const unitJson = unitBundle && unitBundle.jsons[`unit_${unit.code}_${unit.stage + 1}`];
        if (unitJson && cleverapps.Spine.hasAnimation("showup", unitJson)) {
            showUpActions.unshift((f) => {
                tile.animateOpen(false, () => {
                    f();
                    callback();
                });
            });
        } else {
            tile.animateOpen(false, callback);
        }
    });

    this.showUpActions = showUpActions;

    this.processFresh();
};

FogBlockedGround.prototype.processFresh = function () {
    if (!this.showUpActions.length || cleverapps.focusManager.isFocused()) {
        return;
    }

    cleverapps.focusManager.display({
        focus: "ShowUpUnits",
        actions: this.showUpActions
    });
    this.showUpActions = [];
};

FogBlockedGround.prototype.remove = function (x, y) {
    FogBlock.prototype.remove.call(this, x, y);

    for (let i = this.tiles.length - 1; i >= 0; --i) {
        const tile = this.tiles[i];
        if (tile.x === x && tile.y === y) {
            this.tiles.splice(i, 1);
        }
    }
};

FogBlockedGround.ID = "blockedGroundFog";